var module = angular.module('components');
module.component('caSingleselect', {
    templateUrl: 'components/genericcomponents/singleselect.component.tpl.html',
    controllerAs: 'vm',
    bindings: {
        model: '=',
        choices: '<',
        placeholder: '<',
        itemRenderer: '<',
        orderBy: '<',
        filterBy: '<',
        disabledBy: '<',
        mandatory: '<' //Boolean: Tells the component to NOT add a default null value choice
    },
    controller: ['GenericComponentService', controller]
});


function controller(GenericComponentService)  {
    var vm = this;

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;

    vm.filter = filter;

    return;

    function onInit() {
        resolveRenderer();
        addNullValueChoice();
    }

    function onChanges(changes) {
        if (changes.itemRenderer) {
             resolveRenderer();
             addNullValueChoice();
        }
        if (changes.choices) {
            addNullValueChoice();
        }
    }

    function resolveRenderer() {
        vm.renderItem = GenericComponentService.resolveSelectRenderer(vm.itemRenderer);
    }

    function filter(query) {
        return GenericComponentService.getSelectFilter(query, vm.filterBy);
    }

    function addNullValueChoice() {
        //If select is mandatory, do not add null value choice
        if (vm.mandatory && vm.mandatory === true) {
            return;
        }

        //Make sure there is a null value choice in the dropdown
        if (vm.choices && vm.choices.length > 0) {
            //Only add if not aleady present
            if (!_.find(vm.choices, function(c) { return c.id === -1; })) {
                var choiceCopy = { id: -1 };
                if (vm.itemRenderer && Object.prototype.toString.call(vm.itemRenderer) === '[object Array]') {
                    _.forEach(vm.itemRenderer, function(ir) {
                        choiceCopy[ir] = ' ';
                    });
                } else if (vm.itemRenderer && typeof vm.itemRenderer === 'string') {
                    choiceCopy[vm.itemRenderer] = ' ';
                }

                vm.choices.unshift(choiceCopy);
            }
        }
    }
}
